// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementPredictionAppGroupDataResult = objectOf({
  default_update_start_time: number,
  mau: number,
  tbeds_date_active: number,
  universe_all_users_disabled: boolean,
});
